import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ListProject, DeleterProject } from "../../../Utility/Api"; // Import your API functions
import ProjectForm from "./form";
import { Deletemodel } from "../../Common/Functions";
import "./project.css";
import { NaviGate } from "../../../Utility/function";
import { useNavigate } from "react-router-dom";
import ProjectGraph from "./ProjectGraph";

const Projectandexpenses1 = () => {
  const navigate = useNavigate();
  const [Project, setProject] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [deleteModal, showDeleteModal] = useState(false);
  const [deleteID, setDeleteID] = useState("");
  const [selectedData, setSelectedData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const unitsPerPage = 10;

  useEffect(() => {
    fetchProject();
  }, []);

  const fetchProject = async () => {
    try {
      const response = await ListProject();
      if (response.data && response.data.data) {
        setProject(response.data.data);
        console.log("project", response.data.data);
      } else {
        // toast.error("No units found.");
      }
    } catch (error) {
      console.error("Error fetching units:", error);
      // toast.error("Error fetching units");
    }
  };

  const openModal = (unit = null) => {
    setSelectedData(unit);
    setShowModal(true);
  };

  const OpenProjectGraph = () => {
    console.log(currentProject);
    setShowModal1(true)
  }

  const handleDelete = async () => {
    try {
      await DeleterProject(deleteID);
      toast.success("Project deleted successfully");
      fetchProject();
      showDeleteModal(false);
    } catch (error) {
      console.error("Error deleting unit:", error);
      // toast.error("Error deleting unit");
    }
  };

  const handleDeleteModal = (ID) => {
    showDeleteModal(true);
    setDeleteID(ID);
  };

  const handleProjectview = (value) => {
    navigate("/Projectview", { state: { value } });
  };

  const currentProject = Project;
  const [fromDates, setFromDate] = useState([]);
  const [toDates, settoDate] = useState([]);
  const [View, setView] = useState(false);
  const [View1, setView1] = useState(false);
  const handleView = (dataItem) => {
    setSelectedData(dataItem);
    console.log(dataItem);

    if (dataItem) {
      try {
        if (
          dataItem?.project_type == "4" &&
          dataItem?.from_dates &&
          dataItem?.to_dates
        ) {
          var fromdate = JSON.parse(dataItem.from_dates);
          var todate = JSON.parse(dataItem.to_dates);
          setFromDate(fromdate);
          settoDate(todate);
        } else {
          setFromDate([]);
          settoDate([]);
        }
      } catch (error) {
        setFromDate([]);
        settoDate([]);
        console.error("Error parsing fromDates:", error);
      }
    }

    console.log(fromDates);
    console.log(toDates);
    setView(true);
  };

  const handleProjectOverview = (data) => {
    setSelectedData(data);
    navigate('/projectemployeereport', { state : data })
  }

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase">Project List</h6>
          <div className="d-flex column-gap-3">
          <button
            type="button"
            onClick={() => OpenProjectGraph()}
            className="btn btn-primary mb-1"
            style={{ fontFamily: "poppins" }}
          >
            Projects Estimations
          </button>
          <button
            type="button"
            onClick={() => openModal()}
            className="btn btn-primary mb-1"
            style={{ fontFamily: "poppins" }}
          >
            Add Project
          </button>
          </div>
        </div>
        <hr className="mt-1" />


        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table
                className="table table-striped table-sm table-bordered align-baseline"
                style={{ width: "100%", fontFamily: "poppins" }}
              >
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Project Type</th>
                    <th>Hourly Rate</th>
                    <th>Total Hours</th>
                    <th>Total Cost</th>
                    <th>Estimation Cost</th>
                    <th>Paid Cost</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentProject.map((Project, index) => (
                    <tr key={Project.id}>
                      <td>{(currentPage - 1) * unitsPerPage + index + 1}</td>
                      <td>{Project.title}</td>
                      <td>{Project.description?.slice(0, 25)}</td>
                      <td>{Project.start_date}</td>
                      <td>{Project.end_date}</td>
                      <td>
                        {Project.project_type == "1"
                          ? "Fixed Cost"
                          : Project.project_type == "2"
                            ? "Retainer"
                            : Project.project_type == "3"
                              ? "Time & Material"
                              : "AMC Period"}
                      </td>
                      <td>{Project.hourly_rate}</td>
                      <td>{Project.total_hours}</td>
                      <td>{Project.total_cost}</td>
                      <td>{Project.estimation_amount || 0}</td>
                      <td>{Project.paid_amount || 0}</td>
                      <td>
                       <img
                          src="/assets/images/icons/delete.png"
                          className="mx-1"
                          onClick={() => handleDeleteModal(Project.id)}
                          height={"20px"}
                          alt="Delete"
                        />
                        <img
                          src="/assets/images/icons/edit.png"
                          className="mx-1"
                          onClick={() => handleProjectview(Project)}
                          height={"20px"}
                          alt="edit"
                        />
                        {/* <img
                          src="/assets/images/icons/view.png"
                          className="mx-1"
                          onClick={() => handleView(Project)}
                          height={"20px"}
                          alt="Delete"
                        /> */}
                        <img
                          src="/assets/images/icons/view.png"
                          className="mx-1"
                          onClick={() => handleProjectOverview(Project)}
                          height={"20px"}
                          alt="Delete"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${View ? "show" : ""}`}
        style={{ display: View ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                style={{ fontFamily: "Poppins", fontWeight: "bold" }}
              >
                {selectedData?.title}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setView(false)}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body" style={{ fontFamily: "Poppins" }}>
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <strong>Description:</strong> {selectedData?.description}
                    </p>
                    <p>
                      <strong>Client ID:</strong> {selectedData?.client_id}
                    </p>
                    <p>
                      <strong>Start Date:</strong> {selectedData?.start_date}
                    </p>
                    <p>
                      <strong>End Date:</strong> {selectedData?.end_date}
                    </p>
                    <p>
                      <strong>Total Hours:</strong> {selectedData?.total_hours}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <strong>Hourly Rate:</strong> ${selectedData?.hourly_rate}
                    </p>
                    <p>
                      <strong>Total Cost:</strong> ${selectedData?.total_cost}
                    </p>
                    <p>
                      <strong>Project Type:</strong>{" "}
                      {selectedData?.project_type}
                    </p>
                    <p>
                      <strong>Status:</strong>{" "}
                      {selectedData?.status === "0" ? "Pending" : "Completed"}
                    </p>
                  </div>
                </div>

                {/* Project Timeline */}
                {Array.isArray(fromDates) &&
                  Array.isArray(toDates) &&
                  fromDates.length > 0 &&
                  toDates.length > 0 && (
                    <div className="mt-4">
                      <h5 className="text-primary fw-bold">AMC Period </h5>
                      <ul className="list-group">
                        {fromDates.map((fromDate, index) => (
                          <li
                            className="list-group-item d-flex justify-content-between align-items-center shadow-sm"
                            key={index}
                          >
                            <span>
                              <strong>From:</strong> {fromDate}
                            </span>
                            <span className="text-secondary">➡</span>
                            <span>
                              <strong>To:</strong> {toDates[index]}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${View1 ? "show" : ""}`}
        style={{ display: View1 ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-md" style={{marginTop:'100px'}}>
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                style={{ fontFamily: "Poppins", fontWeight: "bold" }}
              >
                {selectedData?.title}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setView1(false)}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body" style={{ fontFamily: "Poppins" }}>
              <div className="container">
                <div className="row">
                  <div className="col-md-6 d-flex justify-content-center">
                          <button className="btn btn-primary" onClick={() => navigate('/projectemployeereport', { state: { ...selectedData, ViewType: 0 } })}>Project Report</button>
                  </div>
                  <div className="col-md-6 d-flex justify-content-center">
                          <button className="btn btn-primary" onClick={() => navigate('/projectemployeereport', { state: { ...selectedData, ViewType: 1 } })}>Employee Report</button>
                  </div>
                  {/* <div className="col-md-12 d-flex justify-content-center">
                          <button className="btn btn-primary">Employee Task Report</button>
                  </div> */}
                  {/* <div className="col-md-6">
                    <p>
                      <strong>Description:</strong> {selectedData?.description}
                    </p>
                    <p>
                      <strong>Client ID:</strong> {selectedData?.client_id}
                    </p>
                    <p>
                      <strong>Start Date:</strong> {selectedData?.start_date}
                    </p>
                    <p>
                      <strong>End Date:</strong> {selectedData?.end_date}
                    </p>
                    <p>
                      <strong>Total Hours:</strong> {selectedData?.total_hours}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <strong>Hourly Rate:</strong> ${selectedData?.hourly_rate}
                    </p>
                    <p>
                      <strong>Total Cost:</strong> ${selectedData?.total_cost}
                    </p>
                    <p>
                      <strong>Project Type:</strong>{" "}
                      {selectedData?.project_type}
                    </p>
                    <p>
                      <strong>Status:</strong>{" "}
                      {selectedData?.status === "0" ? "Pending" : "Completed"}
                    </p>
                  </div> */}
                </div>

                {/* Project Timeline */}
                {Array.isArray(fromDates) &&
                  Array.isArray(toDates) &&
                  fromDates.length > 0 &&
                  toDates.length > 0 && (
                    <div className="mt-4">
                      <h5 className="text-primary fw-bold">AMC Period </h5>
                      <ul className="list-group">
                        {fromDates.map((fromDate, index) => (
                          <li
                            className="list-group-item d-flex justify-content-between align-items-center shadow-sm"
                            key={index}
                          >
                            <span>
                              <strong>From:</strong> {fromDate}
                            </span>
                            <span className="text-secondary">➡</span>
                            <span>
                              <strong>To:</strong> {toDates[index]}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade ${showModal1 ? "show" : ""}`}
        style={{ display: showModal1 ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                style={{ fontFamily: "Poppins", fontWeight: "bold" }}
              >
                {selectedData?.title}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModal1(false)}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body" style={{ fontFamily: "Poppins" }}>
              <div className="container">
                      <ProjectGraph projects={currentProject}/>

                {/* Project Timeline */}
                {Array.isArray(fromDates) &&
                  Array.isArray(toDates) &&
                  fromDates.length > 0 &&
                  toDates.length > 0 && (
                    <div className="mt-4">
                      <h5 className="text-primary fw-bold">AMC Period </h5>
                      <ul className="list-group">
                        {fromDates.map((fromDate, index) => (
                          <li
                            className="list-group-item d-flex justify-content-between align-items-center shadow-sm"
                            key={index}
                          >
                            <span>
                              <strong>From:</strong> {fromDate}
                            </span>
                            <span className="text-secondary">➡</span>
                            <span>
                              <strong>To:</strong> {toDates[index]}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModal && (
        <Deletemodel
          setShowModal={showDeleteModal}
          handleDelete={handleDelete}
        />
      )}

      {showModal && (
        <ProjectForm
          openModal={showModal}
          setOpenModal={setShowModal}
          unit={selectedData}
          closeModal={() => setShowModal(false)}
          refreshList={fetchProject}
        />
      )}
    </div>
  );
};
export default Projectandexpenses1;
